import { useState, useEffect, useCallback } from 'react';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import { mapProcurementDocuments } from '../utils/tenderOpeningHelpers';

const useProcurementDocuments = procId => {
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDocuments = useCallback(async () => {
    const token = getAuthToken();
    if (!token || !procId) return;

    setIsLoading(true);
    try {
      const response = await fetch(
        `${api.API_URL}/procurement/get-procurement-document?ProcurementId=${procId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to load supporting documents');
      }

      const result = await response.json();
      setDocuments(mapProcurementDocuments(result));
    } catch {
      setDocuments([]);
    } finally {
      setIsLoading(false);
    }
  }, [procId]);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  return { documents, isLoading, refresh: fetchDocuments };
};

export default useProcurementDocuments;
